import { Target, ComponentType } from 'data-types-config';
import type { BreadcrumbPatternProps } from './BreadcrumbPattern.types';

export const breadcrumbPatternDefaults: Partial<BreadcrumbPatternProps> = {
  isCurrent: false,
  target: Target.Self,
  componentType: ComponentType.Internal,
  isDisabled: false,
  isVisible: true,
  text: '',
};
